/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PromptGuardrailMessageVerdict,
  PromptGuardrailMessageVerdict$inboundSchema,
} from "./promptguardrailmessageverdict.js";

/**
 * The result of replaying a prompt guardrail against one chat session. Read-only: no findings are persisted.
 */
export type PromptGuardrailEvalResult = {
  /**
   * The chat session that was replayed.
   */
  chatId: string;
  /**
   * True when the guardrail flagged at least one in-scope message.
   */
  flagged: boolean;
  /**
   * Total number of messages matching the guardrail scope before the replay limit.
   */
  inScopeMessageCount: number;
  /**
   * Number of in-scope messages the judge evaluated.
   */
  judgedCount: number;
  /**
   * True when the replay judged only the first 200 in-scope messages.
   */
  messageLimitHit: boolean;
  /**
   * Total OpenRouter cost across in-scope judge calls, in USD.
   */
  totalCostUsd: number;
  /**
   * Aggregate judge latency overhead across in-scope messages, computed as the sum of per-message judge latencies.
   */
  totalLatencyMs: number;
  /**
   * Per-message verdicts for in-scope messages, ordered by seq.
   */
  verdicts: Array<PromptGuardrailMessageVerdict>;
};

/** @internal */
export const PromptGuardrailEvalResult$inboundSchema: z.ZodMiniType<
  PromptGuardrailEvalResult,
  unknown
> = z.pipe(
  z.object({
    chat_id: z.string(),
    flagged: z.boolean(),
    in_scope_message_count: z.int(),
    judged_count: z.int(),
    message_limit_hit: z.boolean(),
    total_cost_usd: z.number(),
    total_latency_ms: z.int(),
    verdicts: z.array(PromptGuardrailMessageVerdict$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "chat_id": "chatId",
      "in_scope_message_count": "inScopeMessageCount",
      "judged_count": "judgedCount",
      "message_limit_hit": "messageLimitHit",
      "total_cost_usd": "totalCostUsd",
      "total_latency_ms": "totalLatencyMs",
    });
  }),
);

export function promptGuardrailEvalResultFromJSON(
  jsonString: string,
): SafeParseResult<PromptGuardrailEvalResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PromptGuardrailEvalResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PromptGuardrailEvalResult' from JSON`,
  );
}
